/* eslint-disable no-underscore-dangle */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getRobotDataAPI, updateRobotDataAPI } from '../api/robot';
// import { findRobotAPI } from '../api/privateManager';
// import { setLocalStorage } from '../common/util';

const MODULE_PRIVATE = 'private';
const initialState = {
  pending: false,
  auth: false,
  error: null,
  config: {
    loading: false,
    item: null,
    result: null,
    error: null,
    message: null,
  },
};

export const findRobot = createAsyncThunk(
  `${MODULE_PRIVATE}/find`,
  async (serial, { rejectWithValue }) => {
    try {
      // const { result, robot, userId, userPId } = await findRobotAPI({ serial });
      // if (result) {
      //   setLocalStorage('currentUser', {
      //     nickName: `${serial} 로봇 매니저`,
      //     robots: [robot],
      //     userId,
      //     userPId,
      //   });
      //   setLocalStorage('robotId', robot.robotId);
      //   setLocalStorage('robotPId', robot._id);
      //   setLocalStorage('manager', true);
      //   return true;
      // }
      return rejectWithValue('유효하지 않은 시리얼 정보입니다.');
    } catch (e) {
      return rejectWithValue('유효하지 않은 시리얼 정보입니다.');
    }
  },
);

export const getConfigData = createAsyncThunk(
  `${MODULE_PRIVATE}/getConfigData`,
  async (robotId, { rejectWithValue }) => {
    const { result, list: data, error } = await getRobotDataAPI({ robotId });

    if (!result || error) {
      return rejectWithValue(
        '로봇 설정을 위한 정보 조회 중 오류가 발생했습니다.\n나중에 다시 시도하세요.',
      );
    }
    const { serial, geo, disturb, reaction } = data[0];
    return { id: robotId, serial, geo, disturb, reaction };
  },
);

export const configUpdate = createAsyncThunk(
  `${MODULE_PRIVATE}/CONFIG_UPDATE`,
  async ({ robotId, ...updateData }, { rejectWithValue }) => {
    try {
      const [name] = Object.keys(updateData);
      const { result } = await updateRobotDataAPI({ robotId, updateData });
      let type;
      switch (name) {
        case 'reaction':
          type = '로봇 성향 설정';
          break;
        case 'geo':
          type = '로봇 위치 설정';
          break;
        case 'disturb':
          type = '로봇 방해금지모드 설정';
          break;
        default:
          type = '로봇 설정';
          break;
      }
      if (result) {
        return `${type}이 성공적으로 저장되었습니다.`;
      }
      return `${type} 저장에 실패하였습니다.`;
    } catch (error) {
      return rejectWithValue(
        '설정 저장 중 오류가 발생했습니다.\n나중에 다시 시도하세요.',
      );
    }
  },
);

const initializeReducer = () => {
  localStorage.removeItem('currentUser');
  localStorage.removeItem('robotId');
  localStorage.removeItem('robotPId');
  localStorage.removeItem('manager');
  return { ...initialState };
};

const privateSlice = createSlice({
  name: MODULE_PRIVATE,
  initialState,
  reducers: {
    initialize: initializeReducer,
  },
  extraReducers: {
    [findRobot.pending.type]: (state) => ({ ...state, pending: true }),
    [findRobot.fulfilled.type]: (state) => ({
      ...state,
      pending: false,
      auth: true,
    }),
    [findRobot.rejected.type]: (state, action) => ({
      ...state,
      pending: false,
      error: action.payload,
    }),
    [getConfigData.pending.type]: (state) => ({
      ...state,
      config: { ...state.config, loading: true },
    }),
    [getConfigData.fulfilled.type]: (state, action) => ({
      ...state,
      config: {
        ...state.config,
        loading: false,
        item: action.payload,
      },
    }),
    [getConfigData.rejected.type]: (state, action) => ({
      ...state,
      config: {
        ...state.config,
        loading: false,
        error: action.payload,
      },
    }),
    [configUpdate.pending.type]: (state) => ({
      ...state,
      config: { ...state.config, loading: true, result: null, message: null },
    }),
    [configUpdate.fulfilled.type]: (state, action) => ({
      ...state,
      config: {
        ...state.config,
        loading: false,
        result: true,
        message: action.payload,
      },
    }),
    [configUpdate.rejected.type]: (state, action) => ({
      ...state,
      config: {
        ...state.config,
        loading: false,
        result: false,
        message: action.payload,
      },
    }),
  },
});

const { reducer: PrivateReducer, actions } = privateSlice;
export const { initialize } = actions;

export default PrivateReducer;
